import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { LinkContainer, EntityListItem, IfPermitted, IconButton } from "components/common";
import { Button, Col, DropdownButton, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { ConfigurationWell } from "components/configurationforms";
import Routes from "routing/Routes";
import recentMessagesTimeRange from "util/TimeRangeHelper";
import ForwarderInputStateControl from "./ForwarderInputStateControl";
import ForwarderInputThroughput from "../metrics/ForwarderInputThroughput";
import ForwarderInputMetricContainer from "../metrics/ForwarderInputMetricContainer";
import ForwarderInputStateBadge from "../states/ForwarderInputStateBadge";
const StyledButton = styled(Button)`
  padding-left: 0;
  vertical-align: baseline;
`;
const ForwarderInputListItem = ({
  forwarder = void 0,
  input,
  inputDescription,
  expanded,
  enableEdit,
  onToggleDetails,
  onDeleteInput,
  onEditInput
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  const _toggleDetail = () => {
    onToggleDetails(input.id);
  };
  const showMetrics = !enableEdit;
  const actions = /* @__PURE__ */ React.createElement(React.Fragment, null, forwarder && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarderinputs:changestate" }, /* @__PURE__ */ React.createElement(ForwarderInputStateControl, { input, forwarder })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "searches:relative" }, /* @__PURE__ */ React.createElement(
    LinkContainer,
    {
      key: `received-messages-${input.id}`,
      to: Routes.search(`gl2_source_input:${input.id}`, recentMessagesTimeRange())
    },
    /* @__PURE__ */ React.createElement(IconButton, { name: "search", title: t("inputs_list_item.show_received_messages"), bsStyle: "default" })
  )), enableEdit && /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      key: `more-actions-${input.id}`,
      title: t("inputs_list_item.more_actions"),
      id: `more-actions-dropdown-${input.id}`,
      pullRight: true
    },
    inputDescription && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `forwarderinputs:edit:${input.id}` }, /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        key: `edit-input-${input.id}`,
        onSelect: () => {
          onEditInput(input);
        }
      },
      t("inputs_list_item.edit_input")
    )),
    /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `forwarderinputs:delete:${input.id}` }, inputDescription && /* @__PURE__ */ React.createElement(MenuItem, { key: `divider-${input.id}`, divider: true }), /* @__PURE__ */ React.createElement(
      DeleteMenuItem,
      {
        key: `delete-input-${input.id}`,
        onSelect: () => {
          onDeleteInput(input);
        }
      },
      t("inputs_list_item.delete_input")
    ))
  ));
  const _getDescription = forwarder ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ForwarderInputMetricContainer, { input, forwarder }), input.configuration && input.configuration.bind_address && /* @__PURE__ */ React.createElement("span", null, t("inputs_list_item.listening_on", {
    address: input.configuration.bind_address,
    port: input.configuration.port
  }), "\xA0"), /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", bsSize: "small", onClick: _toggleDetail }, t("inputs_list_item.show_more"))) : /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", bsSize: "small", onClick: _toggleDetail }, t("inputs_list_item.show_configuration"));
  const additionalContent = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, expanded && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement("h3", null, t("inputs_list_item.configuration_heading")), /* @__PURE__ */ React.createElement(ConfigurationWell, { id: input.id, configuration: input.configuration, typeDefinition: inputDescription })), showMetrics && /* @__PURE__ */ React.createElement(Col, { md: 5, mdOffset: 2 }, /* @__PURE__ */ React.createElement("h2", null, t("inputs_list_item.metrics_heading")), forwarder && /* @__PURE__ */ React.createElement(ForwarderInputThroughput, { forwarder, input })))));
  const titleSuffixExtra = forwarder ? /* @__PURE__ */ React.createElement(ForwarderInputStateBadge, { forwarder, input }) : null;
  const titleSuffix = /* @__PURE__ */ React.createElement("span", null, inputDescription ? inputDescription.name : t("inputs_list_item.unknown_input", { type: input.type }), "\xA0", titleSuffixExtra);
  return /* @__PURE__ */ React.createElement(
    EntityListItem,
    {
      key: `entry-list-${input.id}`,
      title: input.title,
      titleSuffix,
      description: _getDescription,
      actions,
      contentRow: additionalContent
    }
  );
};
export default ForwarderInputListItem;
